@if (panel()) {
  <button
    type="button"
    class="hd-gate-attribute-icon__button"
    [title]="label()"
    [attr.aria-label]="label()"
    [attr.data-panel]="panel()"
    (click)="open($event)"
  >
    <i
      class="fa-regular fa-{{ faName() }} hd-gate-attribute-icon"
      [class.is-visualisation-transparent]="transparent()"
      aria-hidden="true"
    ></i>
  </button>
} @else {
  <i
    class="fa-regular fa-{{ faName() }} hd-gate-attribute-icon"
    [class.is-visualisation-transparent]="transparent()"
    [title]="label()"
    [attr.aria-label]="label()"
  ></i>
}
